




















































































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'
import ModalEquipesProfissionalVincular from './ModalEquipesProfissionalVincular.vue'
import ModalIntegrantesEquipeProfissional from './ModalIntegrantesEquipeProfissional.vue'

@Component({
  components: {
    ModalEquipesProfissionalVincular,
    ModalIntegrantesEquipeProfissional,
  },
})

export default class EquipesProfissionalDataTable extends Vue {
  itemEquipesProfissionalMode: string = 'CREATE'

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get equipesProfissional() { return this.getRegrasDeCalculoStore.equipesProfissional }

  loadEquipesProfissional: boolean = false
  get loadingEquipesProfissional() { return this.loadEquipesProfissional }
  set loadingEquipesProfissional(value: boolean) { this.loadEquipesProfissional = value }

  get paginacaoEquipesProfissional() { return this.getRegrasDeCalculoStore.paginacaoEquipesProfissional }

  get showModalEquipesProfissional() { return this.getRegrasDeCalculoStore.modal.equipesProfissional }
  set showModalEquipesProfissional(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'equipesProfissional', value }) }

  get showModalVisualizarEquipe() { return this.getRegrasDeCalculoStore.modal.integrantesEquipeProfissional }
  set showModalVisualizarEquipe(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'integrantesEquipeProfissional', value }) }

  set selectedEquipeMedica(value: number) { this.getRegrasDeCalculoStore.setSelectedEquipeMedica(value) }

  showModalDesvincularEquipe: boolean = false
  loadingDesvincularEquipe: string = ''
  idEquipeSelecionada: number = -1

  equipesProfissionalHeaders = [
    { text: 'Nome', value: 'equipeProfissionalNome', sortable: false },
    { text: 'Criado por', value: 'createdByNome', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  displayDateAndHours(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  equipesProfissionalDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getEquipesProfissionalAll(param), 700)

  async updatePaginationEquipesProfissional(pagination: DataTablePagination) {
    this.loadingEquipesProfissional = true
    this.equipesProfissionalDebounced(pagination)
    this.loadingEquipesProfissional = false
  }

  async desvincularEquipeMedica() {
    this.loadingDesvincularEquipe = this.idEquipeSelecionada.toString()
    const request = await this.getRegrasDeCalculoStore.desvincularEquipeMedica(this.idEquipeSelecionada)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDesvincularEquipe = ''
      return
    }

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Equipe desvinculada com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    this.loadingEquipesProfissional = true
    this.loadingEquipesProfissional = false
    this.showModalDesvincularEquipe = false
    this.loadingDesvincularEquipe = ''
  }

  showModalIncluirEquipeProfissional() {
    this.itemEquipesProfissionalMode = 'CREATE'
    this.getRegrasDeCalculoStore.setModalEquipesProfissionalMode('CREATE')
    this.showModalEquipesProfissional = true
    this.getRegrasDeCalculoStore.setSelectedEquipeMedicaEdit(0)
  }

  visualizarEquipe(id: number) {
    this.selectedEquipeMedica = id
    this.showModalVisualizarEquipe = true
  }

  editarEquipe(profissionalId: number, id: number) {
    this.itemEquipesProfissionalMode = 'EDIT'
    this.getRegrasDeCalculoStore.setModalEquipesProfissionalMode('EDIT')
    this.showModalEquipesProfissional = true
    this.selectedEquipeMedica = profissionalId
    this.getRegrasDeCalculoStore.setSelectedEquipeMedicaEdit(id)
  }

  deletarVinculo(id: number) {
    this.idEquipeSelecionada = id
    this.showModalDesvincularEquipe = true
  }

  async created() {
    await this.getRegrasDeCalculoStore.getResumoEquipeMedica()
  }

}
